import { Tooltip, Spin } from 'antd';
import { useAiBalance } from 'hooks/api/useAiBalance';

interface Props {
  collapsed: boolean;
}

const Row = ({ label, value, color, collapsed }: {
  label: string;
  value: string;
  color: string;
  collapsed: boolean;
}) => (
  <Tooltip title={collapsed ? `${label}: ${value}` : ''} placement='right'>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: collapsed ? '4px 0' : '3px 0',
      justifyContent: collapsed ? 'center' : 'flex-start',
    }}
    >
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
      {!collapsed && (
        <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.65)', lineHeight: 1.3 }}>
          {label}
          :
          {' '}
          <span style={{ color: '#fff', fontWeight: 600 }}>{value}</span>
        </span>
      )}
    </div>
  </Tooltip>
);

const AiBalance = ({ collapsed }: Props) => {
  const { data, isLoading } = useAiBalance();

  const deepseekValue = data?.deepseek != null
    ? `$${data.deepseek.balance.toFixed(4)}`
    : '—';

  const deepseekColor = (() => {
    if (data?.deepseek == null) return '#555';
    if (data.deepseek.balance > 1) return '#52c41a';
    if (data.deepseek.balance > 0.1) return '#faad14';
    return '#ff4d4f';
  })();

  return (
    <div style={{
      marginTop: 'auto',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      padding: collapsed ? '12px 8px' : '12px 16px',
    }}
    >
      {!collapsed && (
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          AI Balance
        </div>
      )}

      {isLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '4px 0' }}>
          <Spin size='small' />
        </div>
      ) : (
        <>
          <Row label='OpenAI' value='N/A' color='#555' collapsed={collapsed} />
          <Row label='DeepSeek' value={deepseekValue} color={deepseekColor} collapsed={collapsed} />
        </>
      )}
    </div>
  );
};

export default AiBalance;
